import { CollectionMethod } from "../../collection/models/CollectionMethod";

/**
 * Whether the mandate-setup link offers a card only (PD-0043). The link carries
 * `methods=SepaDebit,Card` or `methods=Card`; a link sent before card collection carries
 * nothing and was SEPA, so it reads as not card-only.
 */
export const isCardOnly = (methodsParam: string | null): boolean => {
  if (!methodsParam) return false;
  const methods = methodsParam.split(",").map((m) => m.trim());
  return methods.includes(CollectionMethod.Card) && !methods.includes(CollectionMethod.SepaDebit);
};
